import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector, useAnimations, useTranslation } from "../hooks";
import { delayedHideSoundOverlay } from "../store/slices/sound-overlay";
import { getClasses } from "../utils";
import Commander from "../commander";
import ModalButton from "./buttons/ModalButton";
import modalClasses from "../styles/Modal.module.css";
import classes from "../styles/SoundsOverlay.module.css";

const SoundsOverlay: React.FC<{}> = () => {
  const { soundsOverlay } = useAppSelector((state) => state);
  const [visible, setVisible] = useState(soundsOverlay.visible);
  const dispatch = useDispatch();

  const animations = {
    show: {
      duration: 0.3,
      main: classes["overlay-show"],
      end: classes["overlay-show-end"],
      atStart: () => setVisible(true),
    },
    hide: {
      duration: 0.3,
      main: classes["overlay-hide"],
      atEnd: () => setVisible(false),
    },
  };

  const [animationClass, setAnimation] = useAnimations(animations);

  useEffect(() => {
    setAnimation(soundsOverlay.visible ? "show" : "hide");
    // eslint-disable-next-line
  }, [soundsOverlay.visible]);

  const onClick = (value: boolean) => {
    Commander.soundChoice();
    Commander.toggleMute(!value);
    dispatch(delayedHideSoundOverlay(100));
  };

  const soundOverlay = (
    <div className={getClasses(classes, animationClass, "sounds-overlay")}>
      <div className={classes.message}>
        <div className={classes.title}>{useTranslation("enablesounds")}</div>
        <div className={classes.text}>
          {useTranslation("enablesoundsquestion")}
        </div>
        <div className={classes.buttons}>
          <ModalButton
            className={getClasses(modalClasses, "button", "grey")}
            available={true}
            onClick={onClick.bind(null, false)}
            fill={true}
            name={"no-sound"}
          >
            {useTranslation("no")}
          </ModalButton>
          <ModalButton
            type="accent"
            className={modalClasses.button}
            onClick={onClick.bind(null, true)}
            available={true}
            fill={true}
            name={"yes-sound"}
          >
            {useTranslation("yes")}
          </ModalButton>
        </div>
      </div>
      <div className={classes.backdrop}></div>
    </div>
  );

  return visible ? soundOverlay : null;
};

export default SoundsOverlay;
